import React from 'react';
import Container from '../../../containers/master/activityClasses/showActivityClassContainer';

export default function () {
  return (
    <Container />
  );
}
